import { ChangeEvent, ReactNode } from 'react';
import { Control, Controller, useController } from 'react-hook-form';
import { Checkbox as MuiCheckbox, FormControl, FormHelperText, FormControlLabel } from '@mui/material';

interface CheckboxProps {
  name: string;
  label: ReactNode;
  // eslint-disable-next-line
  control: Control<any>;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
}

const sxStyles = {
  formLabel: {
    marginRight: 0,
  },
};

export const Checkbox = (props: CheckboxProps) => {
  const { name, label, control, onChange, disabled = false } = props;

  const { field } = useController({
    name,
    control,
    defaultValue: false,
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    field.onChange(checked);

    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        disabled={disabled}
        render={({ field, fieldState }) => (
          <>
            <FormControlLabel
              sx={sxStyles.formLabel}
              label={label}
              control={<MuiCheckbox {...field} checked={field.value} onChange={handleChange} />}
            />

            {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};
